// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignUp_signUpContainer__HWd9Z .SignUp_phoneInputStyle__Hd73M {
  width: 100%;
}
.SignUp_signUpContainer__HWd9Z .SignUp_phoneInputStyle__Hd73M input {
  width: 100%;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/service-provider-admin/auth/sign-up/SignUp.module.scss"],"names":[],"mappings":"AAEE;EACE,WAAA;AADJ;AAEI;EACE,WAAA;EACA,kBAAA;AAAN","sourcesContent":[".signUpContainer {\n  \n  .phoneInputStyle {\n    width: 100%;\n    input {\n      width: 100%;\n      border-radius: 3px;\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"signUpContainer": `SignUp_signUpContainer__HWd9Z`,
	"phoneInputStyle": `SignUp_phoneInputStyle__Hd73M`
};
export default ___CSS_LOADER_EXPORT___;
